import { http } from "../client";
export var getAllTimetablesRuleset = function () {
    return http.api
        .get("timetable-programs")
        .then(function (response) { return response.data.data; });
};
